import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Link } from '@reach/router';
import { HOME } from '../constants/Paths';
import BrandLogo from '../assets/BrandLogo.png';
import LogoSmall from '../assets/LogoSmall.png';
import { mobileDevice } from '../constants/DeviceBreakPoints';

const styles = theme => ({
  wrapContainer: {
    padding: '10px 4px',
  },
  rowContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  brandStyle: {
    width: 200,
    objectFit: 'contain',
    [theme.breakpoints.down(mobileDevice)]: {
      width: 120,
    },
  },
  logoStyle: {
    width: 50,
    objectFit: 'contain',
    [theme.breakpoints.down(mobileDevice)]: {
      width: 26,
    },
  },
});

const BrandComponent = ({
  classes,
}) => (
  <Link
    className={classes.wrapContainer}
    to={HOME}
  >
    <div className={classes.rowContainer}>
      <img
        alt="Logo"
        src={LogoSmall}
        className={classes.logoStyle}
      />
      <img
        alt="LinkedField"
        src={BrandLogo}
        className={classes.brandStyle}
      />
    </div>
  </Link>
);

BrandComponent.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(BrandComponent);
